import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, createItem, updateItem, deleteById } from "./paramGroupAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchAll = createAsyncThunk(
  "paramGroup/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const addItem = createAsyncThunk(
  "paramGroup/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response.data;
  }
);

export const editItem = createAsyncThunk(
  "paramGroup/editItem",
  async ({ params, id }) => {
    const response = await updateItem(params, id);
    return response.data;
  }
);

export const removeById = createAsyncThunk(
  "paramGroup/removeById",
  async (id) => {
    const response = await deleteById(id);
    return response.data;
  }
);

export const paramGroupSlice = createSlice({
  name: "paramGroup",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = paramGroupSlice.actions;

export const selectData = (state) => state.paramGroup.data;
export const selectLoading = (state) => state.paramGroup.loading;
export const selectError = (state) => state.paramGroup.error;
export const selectPageNo = (state) => state.paramGroup.pageNo;
export const selectPageSize = (state) => state.paramGroup.pageSize;
export const selectTotalRecord = (state) => state.paramGroup.totalRecord;
export const selectSelected = (state) => state.paramGroup.selected;
export const selectResult = (state) => state.paramGroup.result;

export default paramGroupSlice.reducer;
